import { Component, ElementRef, Inject, OnDestroy, OnInit, Renderer2, ViewChild, ViewContainerRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { distinct } from '@progress/kendo-data-query';
import { Store } from '@ngrx/store';
import { GridComponent, RemoveEvent } from '@progress/kendo-angular-grid';
import { ComponentContainer } from 'golden-layout';

import { PgmDialogEditComponent } from '../../_dialogs/pgm-dialog-edit/pgm-dialog-edit.component';
import { GoldenLayoutContainerInjectionToken, WidgetHostDirective } from '../../../_directives/widget-host.directive';
import { PlanGestionMobilite } from '../../../_models/PlanGestionMobilite';
import { PgmService } from '../../../_services/http/pgm.service';
import { MainStoreState } from '../../../_store/mainStoreState';
import {
  deepLoadPlanGestionMobiliteAction,
  loadPlanGestionMobilitesAction,
  selectAllPlanGestionMobilites,
  selectedPlanGestionMobilite,
} from '../../../_store/PlanGestionMobiliteStore/plan-gestion-mobilite.store';
import { GridWrapper } from '../../../_models/GridWrapper';
import { ConfirmService } from '../../../_services/local/confirm.service';
import { MessageService } from '../../../_services/local/message.service';
import { file } from 'jszip';

@Component({
  selector: 'app-widget-pgm-list',
  templateUrl: './pgm-list.component.html',
  styleUrls: ['./pgm-list.component.scss'],
})
export class PgmListComponent extends WidgetHostDirective implements OnInit, OnDestroy {
  @ViewChild('kendoGrid', { static: true }) kendoGrid!: GridComponent;

  private onDestroy$ = new Subject<boolean>();

  public uploading = false;

  // Grid attributes
  public gridWrapper = new GridWrapper<PlanGestionMobilite>(
    'PlanGestionMobilite',
    this.store.select(selectAllPlanGestionMobilites),
    {
      logic: 'or',
      filters: [
        {
          field: 'description',
          operator: 'contains',
        },
        {
          field: 'commentaire',
          operator: 'contains',
        },
        {
          field: 'descriptionMode',
          operator: 'contains',
        },
        {
          field: 'descriptionEtatDetaille',
          operator: 'contains',
        },
      ],
    },
    this.kendoGrid
  );

  private shouldOpenEdit = false;
  private selectedPgm: PlanGestionMobilite | undefined;
  private sub = this.store.select(selectedPlanGestionMobilite).subscribe((pgm) => {
    this.selectedPgm = pgm;
    if (this.shouldOpenEdit && this.selectedPgm) {
      this.openEditDialog(this.selectedPgm);
      this.shouldOpenEdit = false;
    }
  });

  constructor(
    @Inject(GoldenLayoutContainerInjectionToken) container: ComponentContainer,
    elRef: ElementRef,
    renderer: Renderer2,
    viewContainerRef: ViewContainerRef,
    store: Store<MainStoreState>,
    public crudService: PgmService,
    private messageService: MessageService,
    private confirmService: ConfirmService,
    private dialog: MatDialog
  ) {
    super(container, elRef.nativeElement, renderer, viewContainerRef, store);
  }

  ngOnInit(): void {
    this.store.dispatch(loadPlanGestionMobilitesAction());
    this.crudService.refreshHubConnection();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next(true);
    this.gridWrapper.destroy();
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  delete(event: RemoveEvent): void {
    this.confirmService
      .open(`Voulez-vous supprimer le PGM`, event.dataItem.description, this.crudService.delete(event.dataItem.id))
      .then((res) => {
        if (res) {
          console.debug('supprimé', event);
        }
      });
  }

  dispatchDeepLoadSelectedItem(id: number): void {
    this.shouldOpenEdit = true;
    this.store.dispatch(deepLoadPlanGestionMobiliteAction({ id }));
  }

  openEditDialog(pgm: PlanGestionMobilite | undefined): void {
    this.dialog.open(PgmDialogEditComponent, {
      width: '90%',
      height: '90%',
      data: pgm,
    });
  }

  onFileSelected() {
    this.uploading = true;

    const fileElement: HTMLInputElement | null = document.querySelector('#fileInput');

    if (fileElement && fileElement.files) {
      const formData = new FormData();
      formData.append('file', fileElement.files[0]);
      this.crudService.uploadShapeFile(formData).subscribe((res) => {
        const filename = fileElement.files ? fileElement.files[0].name : '.zip';

        if (res) {
          this.messageService.success(`L'Envoi du Shapefile ${filename} réussi.`);
        } else {
          this.messageService.error(`L'envoi du Shapefile ${filename} a échoué.`);
        }

        this.uploading = false;
        fileElement.value = '';
        fileElement.files = null;
      });
    }
  }

  public distinctPrimitive(fieldName: string): unknown[] {
    return distinct(this.gridWrapper.internalData, fieldName).map(
      // @ts-ignore
      (item) => item[fieldName]
    );
  }
}
